import { LegacyPitcherContext, PitcherContext } from "features/pitcher/Feature";
import { useContext } from "react";

export const useLegacyPitcher = () => useContext(LegacyPitcherContext);

export function usePitcher() {
  return useContext(PitcherContext);
}
